export default {
  INITIALIZE: 'feature/horizontal/INITIALIZE',
  SIZE_CHANGE: 'feature/horizontal/SIZE_CHANGE',
  START_FREE_SCROLL: 'feature/horizontal/START_FREE_SCROLL',
  CANCEL_FREE_SCROLL: 'feature/horizontal/CANCEL_FREE_SCROLL',
  UPDATE_LEFT_AND_RIGHT: 'feature/horizontal/UPDATE_LEFT_AND_RIGHT',
  TIMELINE_ITEM_DRILL_DOWN: 'feature/horizontal/TIMELINE_ITEM_DRILL_DOWN',
  TIMELINE_ITEM_DRILL_OUT: 'feature/horizontal/TIMELINE_ITEM_DRILL_OUT',
}
